// @ts-nocheck
import {Box, Card, Flex} from "@mantine/core";
import React, {useContext, useEffect, useState} from "react";
import SCMessageBarContext from "@/utils/contexts/sc-message-bar-context";
import constants from "@/utils/constants";
import Breadcrumbs from "@/components/breadcrumbs";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {notifications} from "@mantine/notifications";
import StockService from "@/services/stock/stock-service";
import {useRouter} from "next/router";
import * as Enums from "@/utils/enums";
import Storage from "@/utils/storage";
import PermissionService from "@/services/permission/permission-service";
import Helper from "@/utils/helper";
import featureService from "@/services/feature/feature-service";
import StocktakeTemplateForm from "@/PageComponents/Stock Take/Stocktake Template/StocktakeTemplateForm";
import { createFileRoute } from '@tanstack/react-router'

function CreateStockPage() {

    const router = useRouter();

    // Fetch the feature flag to check if stock take is enabled.
    // Redirect to home page if the feature is not available.
    const hasStockTakeQuery = useQuery(['hasStockTake'], () => featureService.getFeature(constants.features.STOCK_TAKE))

    // Redirect if stock take feature is not available
    useEffect(() => {
        if (hasStockTakeQuery.data === null) {
            router.replace('/');
        }
    }, [hasStockTakeQuery.data])

    const queryClient = useQueryClient();

    const stocktakeTemplateMutation = useMutation({
        mutationFn: StockService.postTemplate,
        onSuccess: (data: any) => {
            // Invalidate and refetch relevant queries
            queryClient.invalidateQueries({ queryKey: ['totalStock', router.query.id] }); // TODO(tanstack-router): verify router.query → useParams/useSearch

            notifications.show({
                // title: "Success",
                message: "Stock Item Template has been created successfully",
                color: "scBlue"
            });

            router.replace(`/inventory/list?tab=sttemplates`);
        },
        onError: (error: Error) => {
            notifications.show({
                title: "Error",
                message: error.message || "Failed to update template",
                color: "yellow"
            });
        }
    });

    const messageBarContext = useContext(SCMessageBarContext);

    const onSubmit = (values: any) => {
        stocktakeTemplateMutation.mutate(values);
        console.log('submitting', values)
    }

    const onCancel = () => {
        router.replace('/inventory/list?tab=sttemplates');
    }

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    const [stockAdmin] = useState(PermissionService.hasPermission(Enums.PermissionName.StockTakeManager));

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess || !stockAdmin) {
            Helper.nextRouter(router.replace, "/");
        }

    }, [accessStatus, stockAdmin]);

    return (
        <Box>
            <Flex h={28} align={'center'} px={'lg'}>
                <Breadcrumbs currPage={{ text: 'Create Stock Take Template', link: '/stock-take/template/create', type: 'create' }} />
            </Flex>
            <Box
                mih={`calc(100vh - 40px - 30px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                bg={'gray.1'}
                py={{base: 0, lg: 'md', xl: 'lg'}}
            >
                <Card mx={'auto'} bg={'white'} p={'md'} mt={0} shadow={'xs'} radius={5} maw={1100}>
                    <StocktakeTemplateForm onSubmit={onSubmit} submitting={stocktakeTemplateMutation.isLoading} onCancel={onCancel} />
                </Card>
            </Box>
        </Box>
    );
}

export default CreateStockPage;

export const Route = createFileRoute('/_authenticated/stock-take/template/create')({ component: CreateStockPage })
